import {
  DataTypeKey,
  DataTypeKeys,
  DataTypes,
  DataTypeValues,
  getDataTypeGroup,
  generateTypeChecks,
  DataTypeConfig
} from '../../../utils/data_types'

export type SubSessionTypeFeatures = {
  disableOption: boolean
  geniusAvailable: boolean
}

export const defaultSubSessionTypeFeatures: SubSessionTypeFeatures = {
  disableOption: false,
  geniusAvailable: false
}

export const subSessionTypesConfig = {
  unknown: {
    key: 'unknown',
    name: 'Unknown',
    value: 'Unknown',
    props: {
      features: { ...defaultSubSessionTypeFeatures, disableOption: true }
    }
  },
  broadcast: {
    key: 'broadcast',
    name: 'Broadcast',
    value: 'Broadcast',
    props: {
      features: {
        ...defaultSubSessionTypeFeatures,
        geniusAvailable: true
      }
    }
  },
  demo: {
    key: 'demo',
    name: 'Demo',
    value: 'Demo',
    props: {
      features: {
        ...defaultSubSessionTypeFeatures
      }
    }
  },
  dataGathering: {
    key: 'dataGathering',
    name: 'Data Gathering',
    value: 'DataGathering',
    props: {
      features: {
        ...defaultSubSessionTypeFeatures
      }
    }
  },
  test: {
    key: 'test',
    name: 'Test',
    value: 'Test',
    props: {
      features: {
        ...defaultSubSessionTypeFeatures,
        geniusAvailable: true
      }
    }
  },
  teamPractice: {
    key: 'teamPractice',
    name: 'Team Practice',
    value: 'TeamPractice',
    props: {
      features: {
        ...defaultSubSessionTypeFeatures
      }
    }
  },
  officiating: {
    key: 'officiating',
    name: 'Officiating',
    value: 'Officiating',
    props: {
      features: {
        ...defaultSubSessionTypeFeatures,
        geniusAvailable: true
      }
    }
  }
} as const

export type SubSessionTypeProps = {
  features: SubSessionTypeFeatures
}

export type SubSessionTypes = DataTypes<typeof subSessionTypesConfig>

export type SubSessionTypeKey = DataTypeKey<SubSessionTypes>

export type SubSessionTypeKeys = DataTypeKeys<SubSessionTypeKey>

export type SubSessionTypeValues = DataTypeValues<SubSessionTypeKey>

export const getSubSessionTypeGroup = (items: {
  [key in SubSessionTypeKeys]?: SubSessionTypes[key]
}) => {
  return getDataTypeGroup<
    SubSessionTypeKeys,
    SubSessionTypeValues,
    SubSessionTypes,
    SubSessionTypeProps
  >(items)
}

export type SubSessionTypeGroup = ReturnType<typeof getSubSessionTypeGroup>

export type SubSessionTypeConfig = DataTypeConfig<
  SubSessionTypeKeys,
  SubSessionTypeValues,
  SubSessionTypeProps
>

export type SubSessionType = SubSessionTypeGroup['items'][SubSessionTypeKeys]

export const subSessionTypes = getSubSessionTypeGroup(subSessionTypesConfig)

export const isSubSessionType = generateTypeChecks<
  SubSessionTypeKeys,
  SubSessionTypeGroup
>(subSessionTypes)
